import { createRoot } from "react-dom/client";

import { logTaskListPrint } from "@dashboard/api/task";
import HseAppProviders from "@dashboard/HseAppProviders";

import { ChecklistPrintPage } from "./ChecklistPrintPage";

// Shown only when printing, see print.css.
const PRINT_ROOT_ID = "checklist-print-root";

let unmountPrevious: (() => void) | undefined;

// Round 1: renders the checklist off-screen on the current page and opens the browser print dialog,
// reusing the already cached data. Swap the engine here without touching the UI.
export function exportChecklistPdf(listId: number) {
    // Usage tracking only; a failed log must not block printing.
    logTaskListPrint(listId).catch(() => {});

    unmountPrevious?.();

    const container = document.createElement("div");
    container.id = PRINT_ROOT_ID;
    document.body.append(container);

    const root = createRoot(container);
    unmountPrevious = () => {
        root.unmount();
        container.remove();
        unmountPrevious = undefined;
    };

    root.render(
        <HseAppProviders isDashboardNavigationPending={false}>
            <ChecklistPrintPage listId={listId} onDone={unmountPrevious} />
        </HseAppProviders>,
    );
}
